import { Component } from '@angular/core';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'email-logo',
  templateUrl: './email-logo.component.html',
  styleUrl: './email-logo.component.scss'
})
export class EmailLogoComponent {
  logoPreview: string = '';
  public imgUrl = environment.ImageUrl;

  constructor(private auth: AuthServiceService) { }



  onLogoUpload(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      let formData = new FormData();
      formData.append("image", input.files[0]);
      this.auth.uploadEmailImages(formData).subscribe((res: any) => {
        this.logoPreview = res.body.url || '';
      });
    }
  }
}
